import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "LOLCODE-to-JavaScript compiler babel macro",
  "description": "",
  "published": "2019-05-16T00:00:00.000Z",
  "redirect_from": ["/blog/lolcode-to-javascript-compiler-babel-macro/swizec/9083"],
  "categories": "Computer Science, Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1558022400032.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A fully functioning `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lolcode-babel-macro"
      }}>{`LOLCODE-to-JavaScript compiler`}</a>{` implemented as a Babel macro. You never thought you wanted this and now here it is. You're welcome. 🐱`}</p>
    <p>{`Let me start by proving that this crazy contraption works 👇`}</p>
    <iframe {...{
      "src": "https://codesandbox.io/embed/github/Swizec/lolcode.macro-example/tree/master/?fontsize=14",
      "style": {
        "width": "100%",
        "height": "500px",
        "border": "0",
        "borderRadius": "4px",
        "overflow": "hidden"
      },
      "allow": "accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking",
      "sandbox": "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
    }}></iframe>
    <p>{`Here you have a CodeSandbox with the legendary `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Fizz_buzz"
      }}>{`FizzBuzz`}</a>{` implemented in LOLCODE. A Babel macro compiles it to a JavaScript function at build-time and you use it as any ole JavaScript at runtime.`}</p>
    <p>{`LOLCODE goes in 🐱`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=lolcode&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=HAI%0A%20%20%20%20I%20HAS%20A%20count%20ITS%201%0A%20%20%20%20IM%20IN%20YR%20fizzbuzz%20UPPIN%20YR%20count%20TIL%20BOTH%20SAEM%20count%20AN%2030%0A%20%20%20%20%20%20%20%20I%20HAS%20A%20div%20ITS%20MOD%20OF%20count%20AN%203%0A%20%20%20%20%20%20%20%20IT%20R%20BOTH%20SAEM%200%20AN%20div%0A%20%20%20%20%20%20%20%20O%20RLY%3F%0A%20%20%20%20%20%20%20%20%20%20%20%20YA%20RLY%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20VISIBLE%20%22Fizz%22%0A%20%20%20%20%20%20%20%20%20%20%20%20MEBBE%20BOTH%20SAEM%200%20AN%20MOD%20OF%20count%20AN%205%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20VISIBLE%20%22Buzz%22%0A%20%20%20%20%20%20%20%20%20%20%20%20NO%20WAI%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20VISIBLE%20count%0A%20%20%20%20%20%20%20%20OIC%0A%20%20%20%20IM%20OUTTA%20YR%20fizzbuzz%0AKTHXBYE"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "598px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "73.54260089686098%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'294\\'%20viewBox=\\'0%200%20400%20294\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2034c-2%201-2%2013-2%20113l1%20114c1%202%20355%202%20356%200a2992%202992%200%2000-1-227c-2-3-352-3-354%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/533574aef808a1c6b113a2c58a93e6e8/ca0a1/techletter.app-screenshot-1558022400032.webp 223w", "/static/533574aef808a1c6b113a2c58a93e6e8/75680/techletter.app-screenshot-1558022400032.webp 445w", "/static/533574aef808a1c6b113a2c58a93e6e8/83245/techletter.app-screenshot-1558022400032.webp 598w"],
                "sizes": "(max-width: 598px) 100vw, 598px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/533574aef808a1c6b113a2c58a93e6e8/e92b6/techletter.app-screenshot-1558022400032.png 223w", "/static/533574aef808a1c6b113a2c58a93e6e8/e66bf/techletter.app-screenshot-1558022400032.png 445w", "/static/533574aef808a1c6b113a2c58a93e6e8/0c69d/techletter.app-screenshot-1558022400032.png 598w"],
                "sizes": "(max-width: 598px) 100vw, 598px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/533574aef808a1c6b113a2c58a93e6e8/0c69d/techletter.app-screenshot-1558022400032.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`JavaScript comes out ✌️`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=var%20fizzbuzz%20%3D%20function%20(stdlib)%20%7B%0A%20%20return%20function%20()%20%7B%0A%20%20%20%20var%20IT%3B%0A%20%20%20%20var%20count%20%3D%201%3B%0A%0A%20%20%20%20for%20(%3B%20!stdlib%5B%22BOTH%20SAEM%22%5D(count%2C%2030)%3B%20count%2B%2B)%20%7B%0A%20%20%20%20%20%20var%20_IT%20%3D%20void%200%3B%0A%0A%20%20%20%20%20%20var%20div%20%3D%20stdlib%5B%22MOD%20OF%22%5D(count%2C%203)%3B%0A%20%20%20%20%20%20_IT%20%3D%20stdlib%5B%22BOTH%20SAEM%22%5D(0%2C%20div)%3B%0A%0A%20%20%20%20%20%20if%20(_IT)%20%7B%0A%20%20%20%20%20%20%20%20var%20_IT2%20%3D%20void%200%3B%0A%0A%20%20%20%20%20%20%20%20console.log(%22Fizz%22)%3B%0A%20%20%20%20%20%20%7D%20else%20if%20(stdlib%5B%22BOTH%20SAEM%22%5D(0%2C%20stdlib%5B%22MOD%20OF%22%5D(count%2C%205)))%20%7B%0A%20%20%20%20%20%20%20%20var%20_IT3%20%3D%20void%200%3B%0A%0A%20%20%20%20%20%20%20%20console.log(%22Buzz%22)%3B%0A%20%20%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20%20%20var%20_IT4%20%3D%20void%200%3B%0A%0A%20%20%20%20%20%20%20%20console.log(count)%3B%0A%20%20%20%20%20%20%7D%0A%0A%20%20%20%20%20%20%3B%0A%20%20%20%20%7D%0A%0A%20%20%20%20%3B%0A%20%20%7D%3B%0A%7D(lolcode_macro_dist_lolstdlib__WEBPACK_IMPORTED_MODULE_2__%5B%22default%22%5D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "678px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "107.17488789237667%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'429\\'%20viewBox=\\'0%200%20400%20429\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2029l-1%20186c0%20175%200%20185%202%20186h358c2-1%202-11%202-186l-1-186c-2-2-358-2-360%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5eee2c481035b095844e1cd5c79ad8b8/ca0a1/techletter.app-screenshot-1558022401945.webp 223w", "/static/5eee2c481035b095844e1cd5c79ad8b8/75680/techletter.app-screenshot-1558022401945.webp 445w", "/static/5eee2c481035b095844e1cd5c79ad8b8/7e03f/techletter.app-screenshot-1558022401945.webp 678w"],
                "sizes": "(max-width: 678px) 100vw, 678px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5eee2c481035b095844e1cd5c79ad8b8/e92b6/techletter.app-screenshot-1558022401945.png 223w", "/static/5eee2c481035b095844e1cd5c79ad8b8/e66bf/techletter.app-screenshot-1558022401945.png 445w", "/static/5eee2c481035b095844e1cd5c79ad8b8/38cea/techletter.app-screenshot-1558022401945.png 678w"],
                "sizes": "(max-width: 678px) 100vw, 678px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5eee2c481035b095844e1cd5c79ad8b8/38cea/techletter.app-screenshot-1558022401945.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Taken from Chrome DevTools source maps. That's after Webpack and Babel do their thing. Intermediate output from `}<inlineCode parentName="p">{`lolcode.macro`}</inlineCode>{` is modern JavaScript with lets and consts.`}</p>
    <p><img parentName="p" {...{
        "src": "/29807ffccc9af2cd08d32811094ff220/media-2A6wbh9AZ3tqUNMf5r-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Ok so how does this work?`}</p>
    <p>{`You can see the `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lolcode-babel-macro"
      }}>{`full source code on GitHub`}</a>{`.`}</p>
    <p>{`You can also watch me build `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lolcode-babel-macro"
      }}>{`lolcode-babel-macro`}</a>{` from scratch in a series of livecode videos. 👇`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=-5GN_ozw7rk"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M389%206c0%202%200%203%202%203l1%204-1%204c-2%200-3%2020-1%2022v6c-2%208-1%2020%201%2020l1%204-1%204a329%20329%200%2000-1%2059l-1%206-1%205c-2%200-3%202-1%202l-20%201-21%201v5h21l22%201h-22l-21%201-1%207c0%206%200%207%202%208l3%201h-3c-2%200-2%200-2%206l1%206h22l22%201h-22l-22%201v11h21l22%201h-22l-21%201-1%206v7l-1-1h-1l-2-1c-1-2-5%201-5%204-1%203-1%203-3%202-2-2-11-2-12%200h-3c-1-2-19-1-22%200-1%201-2%201-2-1h-53c0-1-12-1-13%201-2%203-3-4-3-35v-31H116l1%2020-1%2021a419%20419%200%2000-42%203c1-1%200-2-1-2-1-1-1-1%201-2h-4c-6%200-9%201-9%203l-1%201-2-1-5-1c-5%200-6%200-6-2%200-6%206-12%2012-12%205%200%205%200%207%205l3%205%206-1%207-1h-6l-6-1%201-2-1-13v-4c0-2%200-2-2-1-3%201-6%200-6-2%201-2-4-2-33-2l-27%201-1%203-1%2033v29h401l-1-108V2h-11v4M11%206c0%203%200%203-5%203H1v7h11c10%200%2013-1%2010-3v-2c1-1%20158-2%20161%200%202%200%203%203%201%203l-1%201%2021%201h21v-3c1-6-2-11-3-6l-1%203V5L116%204H11v2m179%20100v12c1%202%2013%203%2017%201%203-1%203-1%203-7v-6l-10-1-10%201M68%20193l-3%201-2%201h-1c0-3-3-1-3%203l-1%203%202%201%205%203c2%203%204%202%204-2l1-4v-3l1-3c1-1%201-1-1-1l-2%201m7%205v5l-1%203-3%201-2%202c-1-1-4%203-4%204l10%201h9c0-2-4-6-6-6l-1-5c0-6-2-10-2-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/23e318978b299d694805fb9c13615786/ca0a1/techletter.app-screenshot-1558022408824.webp 223w", "/static/23e318978b299d694805fb9c13615786/75680/techletter.app-screenshot-1558022408824.webp 445w", "/static/23e318978b299d694805fb9c13615786/0ba47/techletter.app-screenshot-1558022408824.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/23e318978b299d694805fb9c13615786/e92b6/techletter.app-screenshot-1558022408824.png 223w", "/static/23e318978b299d694805fb9c13615786/e66bf/techletter.app-screenshot-1558022408824.png 445w", "/static/23e318978b299d694805fb9c13615786/6af66/techletter.app-screenshot-1558022408824.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/23e318978b299d694805fb9c13615786/6af66/techletter.app-screenshot-1558022408824.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=jM_qSs4TBd0"
      }}>{`part 2`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=LxekQLDmgHw"
      }}>{`part 3`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=C0OTz47m1To"
      }}>{`part 4`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=dGzXWM7qJ5o"
      }}>{`part 5`}</a></p>
    <h2 {...{
      "id": "what-is-lolcode"
    }}>{`What is LOLCODE`}</h2>
    <p><a parentName="p" {...{
        "href": "http://www.lolcode.org/"
      }}>{`LOLCODE`}</a>{` is an esoteric programming language from 2007. The peak of the lolcat meme when the internet was for cats.`}</p>
    <p>{`You might remember i can haz cheezburger?`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "273px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/623450dfe36916d72f128cd0e2751b98/e2ee2/full-875511040-h8EB4D6E9-.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "145.73991031390133%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'583\\'%20viewBox=\\'0%200%20400%20583\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M11%201L7%202C5%202%203%202%202%204c-2%202-3%209-1%209%203%200%209-4%209-5l2-2%202-3c0-2-1-3-3-2m26%200a195%20195%200%20014%208v4l1%206%201%2010c0%209%201%209%204%206%202-2%203-2%208-1%203%201%208%209%207%2011s0%2018%201%2019c2%201%201%204-2%203l-4%201c-2%202-9%206-15%207-5%202-8%201-11-3-2-2-3%200-3%205l-1%206-1%204c0%202-1%203-3%203-3%200-3%201%200%203%204%203%205%203%206-1%202-4%204-3%207%205%203%2010%202%2018-2%2021l-4%203c-4%203-11%203-15%200-3-2-6-3-9-1l-4%202c-2%200-2%200-2%208l1%2010%201%205c-1%204%200%207%201%2010a204%20204%200%20014%2011c8%206%2010%209%208%209l-7%204-7%204-1%209c0%209%200%209%202%209%203%200%207-5%206-7s1-3%204-3c2%200%201%202-1%204-1%201-2%202-1%203l-2%203-2%202%202%201c3%202%206%202%205%200-1-1%201-8%202-8l1-2%202-2c1%200%202%200%202-2%201-3%202-2%202%202%200%203-4%2012-5%2013-2%201-1%203%201%203l4%201-3%201c-3%200-6%203-6%206%200%202-5%208-5%206%200-3-3-3-3%200l2%202c2%200%201%202-3%207-6%207-5%208%205%204l6-3c4%200-5%205-13%208-2%200-2%201-2%2010l1%2012%207%2019%204%209%201%202%205%2013%204%2012c-2%201-7-1-7-4l-3-5-2-4-2-3-2-6c-1-5-4-9-5-9l-1%2026a131%20131%200%20002%2029l-1%203-1%204c0%204%200%205%203%205h5l-2%202v2c0%202%200%202-2%201-4-3-4-2-4%204%200%205%200%206%202%207%204%201%206%203%207%205%201%204-1%207-3%207-3-1-6%203-6%208%200%204%200%205%202%205l1%201-1%201c-2%200-2%202-2%2013v13l5-1c6%200%2012%203%2013%206l3%202c2%200%204%202%203%203l1%203v2l-1%202c0%201-6%202-9%201h-3c-2%200-6-2-6-4l2-4c2-4%202-6-2-3H2c-2%200-2%201-2%2024v25h3c6%202%208%202%2016%202l22%204h14v-11l-1-9-1-8c0-2-1-3-3-3s-3-3%200-3v-1l-1-1c2%200%203-2%201-2v-7c-1-5-2-6-3-4l-3%202v-6l-2-2c-2%200-3-1-1-3s3-1%203%201%200%202%201%201l1-3c-1-2-2-29-1-32%201-2-2-10-4-10l-7-5c-4-4-7-6-10-6l-4-1%203-3c3-4%204-4%206%201%202%203%202%204%204%201l3-2c5%200%206-2%207-10%201-11-2-17-7-17l-4-1c-2-2-10%200-11%203l-2-1c-3-4%200-15%205-17h8c4%201%205%201%205-1l3-6c4-7%208-17%208-20l1-3v-3l1-4%201-3%201-4%203-10%202-7-2-2-2-3-5-14c-6-12-6-11-15-11l-4-1%208-1c6%200%208-1%205-2-2-1-2-4%200-5%201-1%201-3-3-7v-4c1-3%201-3-1-3l-3-1%201-1c2%200%204-3%204-4l1-4%201-7%202-4c1-2%200-4-3-3h-1l5-10v-1c0-2%2013-15%2017-17l3-5%202-7c1-2%202-4%201-5l1-3c1-1%203%207%203%2012%200%204%201%205%205%206l2%202%201%202c3%201%202%203-2%203-3%200-4%201-5%202l-3%201c-2%200-2%200-1%201h4c2%200%202%200%201%202l-3%203c-3%200-3%203%201%204%204%202%2010%202%2011%201h1l-1%203c-2%203-2%209%201%2011%202%202%203%202%202-1-1-2%200-13%201-12l3-1c3-1%204-1%205%201%202%201%201%204-2%204-4%200-4%206%200%2011%204%204%2011%201%2013-6%201-2%201-2%201%201l-1%206c-3%202-2%203%200%203%204%200%205-3%204-12-1-8-3-12-6-12v-2l-2-1c-2%201-6-1-6-3l-6%201-7%204c0%202-2%201-4-1v-2l1-1c0-1%201-2%203-2%202-1%202-1%201-3l-1-1h2l2-1h2l1-2c0-3-2-5-3-3l-2%201%201-2v-3c0-2%200-2%203-2s5%202%204%203l-2-1c-2-3-2%200%200%203l3%204%202%201c-1%202%205%207%208%207v-12l-1%201c0%202%200%202-1%201l-3-1c-2%201-4-3-3-5%201-1%201-1%201%201%201%202%209%202%2010%200l1-3c3%200%206%205%205%208a971%20971%200%2000-1%2013c-1%204%202%204%203%200l2-4%201-3%202-3%201-2%201-2c2-1%203-1%203%201v10c-1%205%200%205%202%201l2-3%201%203c1%204%201%205-2%205l-1%202v5c2%202%201%202-2%203-2%200-3-2-1-3s0-6-2-6l-1-1c0-2-4%203-5%206%200%202%200%202%201%201l2-3c0-2%200-2%201-1h1l1-1c1%200%200%204-2%206l-1%205c1%205%203%205%204%201l1-3%202%205v3h1c2-2%204-1%203%202h1c2-2%203-1%203%201s0%202%202%201l1-3c0-1%203-1%204%202%201%201%201%201%202-1%200-1%201-2%202-1%202%200%202%200%202-2s1-3%202-3l1%202c0%202%200%202%201%201%202-1%202-1%201%202%200%204-6%2010-8%2010l-1%201a866%20866%200%20010%207c1-1%203-1%205%201%205%201%206%201%204-2v-3c2-2%202-2%202%202%201%206%207%209%2012%207l2-2%201-1%203-3%201-2c1%205%201%206-1%206l-1%201-1%201c-2%201-3%201-2%203s10%201%2011-2c2-1%202-1%203%201l4%202c2%200%203%201%204%203%200%202%202%203%202%201%200-4%201-4%202-5l1%202%202%203v4c-2%201%200%206%202%206l1%202c-1%202%200%204%202%203l1%202%202%202%201%206%201%203v1l-2%202-1%204c-1%203%200%204%204%204%204-1%204-3%203-6v-3c1-1%202-2%201-3h2l2%202c0%203%202%205%203%205v-12c-1-4-1-5-4-5l-2-1%202-1c2%200%201-2-1-3s-3-1-2-3l2-1h1l-1-1c-1%200-1-1%201-2v-2l-3-2-2-2%203%201c3%200%203%200%202-1l-2-2a264%20264%200%2001-1-4l-3-3c-1-3-1-3%204-2%204%201%207%205%206%207-1%201%200%202%201%203l2%203%201%201c1-1%200-8-2-13-2-3-2-4-1-5h1l2%202c2%200%202%200%201-2v-4c2%204%206%202%2011-7%203-7%204-7%201-6l1-2%205-7c3-6%204-6%203-2l1%203c2%200%201%202-1%203-2%200-2%201-1%201%203%204%200%2022-3%2026-3%202-3%203%201%206l3%204c-2%201%202%208%205%2010l3%203c0%202%204%203%204%201l-1-2v-2c0-2%200-2%201%200%203%203%203%206%201%206l1%202c6%204%2011%2010%2011%2012s3%204%206%203l7-12a243%20243%200%200115-27l8-15c4-8%205-9%208-6%201%203%201%203-3%2010a287%20287%200%2001-23%2040l-4%207-4%208c0%204%200%205-2%205-3-1-2%203%202%205%203%202%204%203%202%203-3%203%200%205%204%205h4l1%202%202%202c0%202-2%201-4-1-1-2-5-3-6-1l-5%201c-5%200-5%201-1%205l3%204c-1%200%200%202%202%203l2%203%202%204c1%203%200%204-2%203-3%200-2%201%200%205%202%201%203%203%202%203v4l-2%203c-3%201-1%203%202%203l2%202-2%201-3%201%201%201%202%204%201%203-2%202c-3%201-3%203%200%203%202%200%201%202-1%202l-2%204-2%205-1%205-1%204-4%2016%201%208%201%206%201%204%201%208c1%205%200%2020-3%2028v6l-1%204-2%204-1%202c-2%201-5%207-6%2012l-3%209-4%2016c-2%2012-4%2018-9%2031-2%206-2%207-1%2014%202%2020%202%2036%200%2037h-7l-1-4c-2-3-2-4-7-4-11-2-14-2-15%200l-1%202c-1%200-5-5-5-7l-1-2v4c0%202%200%203-2%203-3%200-9%202-8%203v1l-1%202c0%202-2%203-6%203s-9-2-6-2c2%200%203-2%201-2v-2l2-11a5141%205141%200%20013-22c2-2%203-1%202%201%200%202%200%202%202%201s2-2%202-6l1-5v4l1%203c1%201%200%204-3%206v3l3-2c3-4%205-3%203%201-3%204-2%204%200%203l2-3h2l4%202c1%200%202%200%202%202l1%203v-3c1-3%203-3%204-1l-2%203c-2%200-3%202%200%202%201%201%201%200%202-2l3-2%201-2%201-2c2%200%206-4%206-5h-2l-2-1c0-2%202-3%205-3s2-1-1-3c-4-1-4-4%200-4l1-2-1-2c-2%200-4-4-3-4%201-1%204%201%203%202h4c1-1%200-4-2-4s-3-4-2-4v-2l-2-3c0-1%200-2-1-1l-1-2h3l4%201h6c3%202%204%200%200-3a483%20483%200%20011-3c3%200%204-5%202-5s-2-2%200-4l2-2h2l-1-2v-2l2-5c0-2%200-2%201-1%201%202%204%201%205-2l2-2c2%201%201-2%200-3-2-1-4%200-3%202l-5%201c-5%200-7-2-5-4%201-1%201-1-1-2-1-2-2-3-1-5%200-2%200-3-2-5-3-3-3-3%202-4s7%200%207%204c0%201%200%202-1%201%200-2-5-4-5-3%200%203%206%2010%207%209v-2c-2-1-1-2%202-1%204%200%209-1%208-2l-2-1c-2%200-2-1-2-4h3l2-1c-2-2-9-1-8%201s-2%201-4-2-2-4%201-2h9c3%200%204%200%204-2l-1-1c-2%200-1-2%201-5%202-2%202-2%201-4l-2-3-1-1-2-1%201-1v-2l-2-3-3-3c-2%200-3-2-1-3%201%200%203%201%205%204l5%203-1-2-3-6-1-5-1%201c1%201-2%203-3%202v-2c2-1-1-4-3-4-1%201-3%200-4-1s-3-2-4-1c-5%201-6-1-4-4l2-1%202%201%201-2c0-2-3-3-4-1h-1l-2-1c-3%200-3-3-1-5s4-3%204%200c-1%201%200%201%202%201l2-1v-1c2-1%201-3%200-3l-2-1%204-1c3%200%204-2%201-3l-2-1-2-2c-4-2-4-4%200-3%202%200%202%200%200-2l-4-3c-2-2-2-2-1-3%203-1%202-5%200-6-3%200-2-2%201-2s5%202%204%205c-1%202-1%202%201%206%202%202%203%204%202%205-2%200-1%202%201%202%201-1%201%200%201%201l2%202%202-1v-2l5%206%201%201%203%203%202%204c3%200%205%201%202%202s-4%204-1%204c2%201%203%209%200%209-2-1-2%207-1%208%203%202%205%201%204-2l1-6v-13l1-5-1-2-2-2c-2-1-3-7%200-7%202%200%201-3-1-4v-1c3%200%203-2%201-4-1-2-4-1-2%201l-1%201-4%201-2-1v-2c-4-1-4%202-1%205s0%204-4%201c-5-3-6-9-2-8%202%200%202%200%201-1v-3l1-1%202-2%202%201v2c2%200%204-2%202-3l-1-2c0-2%200-2-4%200h-5l1-1c2%200%201-3-1-5l-5-2c-3%200-7-3-5-4v-3c1%201%202%200%203-1v-1c-1%201-2%200-2-1l-2-1v-1h3c1%201%201%201%201-1-1-2-1-2%202%200%203%201%203%201%201%203-1%201-1%201%201%201l3-1c1-2%202-1%202%201l1%202c3%200%206%202%206%203-1%201%205%202%207%201%202-2-2-6-4-5-3%201-9-2-9-4l-2-2c-2%200-4-2-3-3l3%201h7c0-2-3-4-5-3-2%200-2%200-1-1l-2-3-2-3-1-2-1-2c0-3%200-3-3-3l-4-1c0-3%205-2%208%200l3%201-3-3c-4-3-4-10%200-10%201%200%202%200%201-2l1-3c1-1%201-1-1-1-3%200-4-1-1-3l1-5v-1l2-1-1-2c-2%200-1-3%201-4l1-2h-1l-1-1%201-1c2-1%201-4%200-3l-2-1-3-1c-2-1-3-1-3-5l1-5%201-2v-3c2-4%200-7-3-6-3%200-5%202-3%202v1c-2%202-2%203-1%205%200%204%200%204-2%204l-3%201-1%203-3%205-5%207-2%204c2%201%201%202-2%202-2%200-4%201-6%204l-6%204-1%201-4%202-3%203-3%201-4%202-4%201c-2-1-4%200-6%201-3%203-4%203-3%200l-1-3-2%202c-1%202-1%201-1-1%200-4%203-7%205-4%204%204%205-1%202-8-2-4-1-5%201-2l3%204%203%204c1%201%201%201%201-2v-7c-3-4-2-5%201-1%204%204%204%203%203-1v-3c1-1%201-1%201%201l2%203c2%201%204%201%202-1s-1-3%201-3c1%200%202-1%201-2%200-2%200-3%202-3%201%200%202%201%201%202%200%202%200%202%203%202%204%200%204%200%203-2s-5-5-7-5c-1%200-2-1-1-2h-1c-3%201-10-3-8-4l2-3c1-1%201-1%203%201l3%202c1-1%200-5-2-5l-1-3-1-3-1-3c0-1-2-2-7-2l-6-2-2-1-2-2c0-2%200-3-2-2l-3-1c0-2-2-2-3-2-2%201-2%201-2-2%201-3%200-3-2%200-1%201-2%202-3%201-2%200-3%201%200%203l1%203c0%202%204%206%205%206l1%201-3%201-6%201c-5%202-13%202-17-1s-9-3-6%201c1%201%200%201-3%201s-4-1-4-2l3-1%202-1-3-1-4-2-2-1%201%203c2%202%202%203-1%201l-2-2-1-2-2-3-1-2c-2%200-5-8-4-9%202-3%209-6%2014-6%204-1%205-2%205-3l1-4c1-4-2-7-3-4l-3%202-1%202c1%202-1%205-3%203-4-4-12-6-19-5-2%200-3%202-1%202%202%201%204%209%204%2012%200%202-1%203-4%203-4%200-6%202-3%202l-1%201-2%202h-9l-8-5c-5-4-7-5-13-4-4%200-4-2-1-3%202%200%202%200%200-1l-2-1%202-1%203-1-3-2c-3-3-7-3-8-1%200%202-2%203-2%201%200-1-1-1-1%201-1%202-1%203%201%202l1%201-3%201a778%20778%200%2001-2%207c-1%200-2%203%200%204l2%204c0%202%200%203%202%203%203%200%203%200%202%202-2%202-1%207%201%207%206-1%209%201%205%203-2%201-2%201%200%202%203%201%203%201%202%203s-1%202%201%203c4%201%204%202%204%205l1%203v2l1%202%203%205c2%203%202%203%200%204-1%201-2%202-1%203l-1%204c-2%201-2%202-2%204%201%202%201%203-2%204-5%201-5%204-1%203s8%202%207%206l1%203%201%201c0%202-3%201-3%200-1-3-3-2-3%201s1%204%203%205c3%202%2014%2012%2014%2014l2%202c2%200%203%202%203%204s-5%200-8-4c-3-3-6-4-6-2l2%202%201%202%202%204c2%201%203%203%202%203%200%201-3%200-3-2l-4-3-4-4-3-1c-1%200-2-1-2-3l-1-4-1-2c1-2%200-2-3-2-4%200-4%201-1%204%202%201%204%205%205%208l4%206%201%202c0%202%200%203%202%203l3%201%202%201a291%20291%200%20016%203c0%202%205%203%205%201%201-2%201-3-1-2v-2c2-2%202-3%200-3l-1-1%202-1%201-1c0-2%202-2%203-1l-2%203v1c3%200%205%203%202%203s-2%203%204%208l5%206c0%202-2%202-5%200l-4-3-2-1v-1l1-2h-1l-3%201c-3%200-4%202-2%204l2%202c0%202%201%203%207%204%205%201%206%200%208-1%201-2%204-3%204-1l-2%201c-2%202-1%204%202%203%202%200%203%201%201%203-2%201-14-1-17-3l-2-1c-1%201-5-3-5-5l-2-1c-1%200-15-13-15-15s-3-3-4-2c-3%202-2%202%201%206%202%202%203%203%204%202%202%200%202%200%201%202l1%202%202%202%202%203%204%203%204%206c5%206%202%206-3%201l-7-6-4-2h-4l-4%202h-3l2%202%203%203c-1%201%200%201%201%202l2%201%202%201%202%201%202%201c1%200%202%200%201%202h2c2%200%203%200%205%202l3%202%201%201%203%202%202%202c0%202-2%203-3%201h-2l-8-3-1-1-3-2c-2-2-6-4-11-4-4%200-6%202-2%203l5%203%204%202c1%200%202%201%201%203l1%202%203%204c1%203%200%203-1%203l-2%202h5c4-2%208-1%207%201%200%202-2%203-2%201h-2c-2%201-3%204-1%206v2h-2c-2-4-5-2-6%204l2%203c2%200%203%202%201%204v1l1%202c-1%204%200%204%202%202l2-2c2%200%202%207%200%2010-2%204-2%2010%200%2010l1-2%201-2v2l1%202%201%202c1%202-1%203-3%202h-7c-2%202-5%201-6-2l-3-1c-2%200%207%208%209%208v1l2%201h6c4%201%204%201%204%204s0%204%202%204c5%200%205%200%205%202l-2%204c-3%203-4%206-2%204%202-1%204%202%204%205%200%202%200%203-1%202-1-4-7-5-7-1l-2%205%201%203%201-1c-1-1%200-4%202-4l3%203%203%203%202%202v5c-1%200-2-1-1-3%200-3%200-3-1-2-2%200-2%201-2%203%201%202%201%202-1%203l-2%202-1%202v3c0%202-1%206-2%204-1-1-1-1-3%201s-2%205%201%203l3-1c2%201-2%205-5%204l-2%201c-1%201%203%203%205%203h4c3%200%207%202%207%205l2%201c2-1%202%200%202%204s-2%206-3%202-3-3-3%201c0%203%200%204%203%205h3l3-4%202-4c0-1%202-2%2015-2h14l1%203c0%202%201%203%202%203h1c1%203-2%203-11%203-6%200-8%200-11%202l-8%202-3%203-5%2010-1%204-2%205c-1%201-1%201%205%201l10-3%2011-1%205-1c1-1%2011-2%2013-1l4%201h8c2-2%209-1%2010%201%202%202%205%204%206%203l5%202-10%201a874%20874%200%2000-24%202v2l-2-1c-1-1-3-2-8-2l-4%201%203%201h-7c-1%202-6%202-8%201h-2c-1%202-2%202-3%201v-3h3c2-1-1-2-6-1-3%200-3%200-1%202v1l-2%201h-1v-2l1-1h-9c-1%201-1%201%200%200l-2-1h-2l-4-1-4-1h4l4-1c1-1%200-1-1-1-2%200-2%200-1-1%202-1%200-6-5-11-2-3-3-3-5-2s-3%205-1%206c1%201%200%202-2%203-1%201-1%201%201%202%203%203-2%206-9%206-4%200-7%201-4%202v1h-3l-1-1c1-2-4-1-8%200l-3%201%201-1-13-1H0v16h116a3158%203158%200%2000118-1l84%201h83v-17h-4l-3-1%201-1v-2c2%200%201-2-1-3l-3%202c-2%203-3%204%200%203l1%201h-10l-2-2c-2-1-2-1%200-2l6-1%203-1c-1-1%201-1%207-1h4v-8c0-7%200-8-2-10-2-1-2-2-1-4l1-1%201%201%201-6v-6h-3c-4%201-7%200-7-3s4-3%205-1c2%203%205%203%205-1V7h-8c-7%200-10-1-10-4%200-1-1-1-3%201-4%203-11%203-23%202-12-2-17-2-19%201-1%204-2%2010%200%2010l2%202c2%202%201%203-3%203l-3%203-1%204c0%203%201%205%203%203h11l-1%203c-2%200-3%203-2%204h2c2-1%203%201%202%204-1%202-3%203-3%201l-1-2c-14-1-13-2-13%2012l-2%2011%201%201c2%200%203-3%203-7l1-5c2-2%204%2010%203%2018%200%202%201%204%204%207%203%202%204%205%204%206l2%205a1701%201701%200%20006%209h-4c-3-1-3-1-6%202-2%203-3%204-6%203-4%200-6%201-5%203h3l3%202%201%201%202%201%201%201-2%201c-1%200-2%200-2%202s0%202-6%200l-5-1-1%2010c-1%2011-3%2017-4%2015a405%20405%200%2001-2-63c0-5-2%202-3%209%200%204%200%207-2%208v4c2%201%202%203%202%209v7h-6l-5%201v-8l-1-7v15l-5-1h-6v-12c-1-12-2-16-4-8%200%204-1%205-3%205s-2%200-2%204v4h4c3%200%203%200%203%203%200%204%201%204-9%204l-9%201V97c-1-22-1-20%2011-21h20l1-4c1-6%2010-11%2013-7a1299%201299%200%20006-53l1-8-8-1-11-1-6-1h-2c-2-2-28-1-30%200l-4%203c-4%200-9%203-11%205l-3%201-11%203h-6c0-3%204-10%206-10%204-1%202-3-2-3-5%200-6%201-8%207-3%209-3%2011-5%2011-1%200-2%201-2%205l1%205%201-5v-4h6c5%200%206%201%206%203s0%202%202%201h1l2-1c1-3%201-3%208-3h8v4a175%20175%200%20003%2015%20495%20495%200%20003%2014v4h-11v-3c0-4%200-4-2-4-3%200-3%200-3%204v3h-11v-5l2-10%201-8v-4l1-2c0-2%200-2-2%201s-2%205-3%2013c0%2016%200%2015-3%2015-4%200-5%200-5%205-1%206-4%2010-8%2013s-5%204-4%2024c0%2012-2%2014-12%2015-6%201-7%201-10-2l-3-4c-1-1-1%200-2%202-1%204-4%205-9%205-3%200-3%200-2%201%202%202%201%207%200%207l-2-2c0-1-4-1-7%201-1%201-1%201-1-1l1-2%201-1%201-2c1-1%200-1-1-1-2%200-3%200-2%202l-1%201-3-2-11-1h-10v-13a55%2055%200%20003-6c2-6%202-10%200-10s-2-1-2-4v-4l4-1%207-1h2l2%201v-1l1-2%201-1c-1-2%204-1%206%201%202%203%206%204%208%202h7l4%201%201-1h1c2-2%203-1%202%203l-1%205v2c-2%200-1%208%200%208%203-1%203-2%202-8l1-12%202-8%202-2%201-1c-2%200-2%200%200-1l2-2%207-2c5%201%205-2%200-6l-3-5-1-4h10V19h5l6-1c2-2%201-3-1-3l-2-1h2c2%200%202%200%202-2V9h-1l-1%201-1%202-1-1c0-2-4-1-5%201h-2c-2%200-2%200-2%203s-1%204-3%205l-2%201-3-5c-2-2-2-3-1-5%202-3%2012-7%2019-7%204%200%208-1%208-3l-13-1h-13l-2%203-2%204c0%202-3%203-9%203h-6l5%201%208%204%203%203h-3l-6-1-4-1c-1%202%201%202%206%203l5%201v17c0%2019%200%2021-2%2019-2-1-12%201-11%202l-2%202%201%201c1%201%201%201-1%201s-3%200-2%201l-1%201c-1%200-2%200-1%201l2%201c4-2%205%203%201%205-2%201-5%200-3-2l-1-1-1%201h-1l-2-2c-4-1-4-3%200-4%202%200%203%200%202-1-2-1%202-4%205-4%202%200%201-1-1-1-3%200-4-1-4-3-1-2-1-2-1%200s-1%203-6%203c-4%200-5-1-5-3%200-6-5-7-5-2%200%204-3%206-6%205h-3l-2%201%202%201%203%201h-3c-3%200-5-2-6-4l-2-1c-1%201-2%2021-1%2022a216%20216%200%2001-1%2029c2%204%201%207-3%208l-4%201%206%204%202%201c1%203%2019%205%2019%203l-2-2c-3-1-5-4-4-5l3%201%203%202c2-1%203%202%203%204l1%202%209%204%2011%204%207%204%209%202%205%201c8%204%2013%205%2024%205s12%201%2017%203c7%204%207%205%205%2014l-3%209v-7c1-9%200-11-8-14-5-3-12-2-28%202a1398%201398%200%2001-17%205h-11c0-2-5-6-6-5l-3-2c0-2-1-2-3-2-2%201-3%201-3-1h-1l-2%203-4%202h-3l-2-2-4-2-1-2v2c1%201%200%202-1%202l-1-1-1-1h-5l-2%202c-2%200-1%202%201%202%201%201%201%201-1%201-1%200-2%200-1%201%200%202%200%202-3%201-3%200-4%201-1%203%201%202%201%202-1%202l-2%201c0%202-2%204-3%203l3-9%201-3c0-4%201-5%203-5%201%201%201%200%202-1l1-1c1%202%208%200%208-2s-1-3-3-1-2%202-2%200c-1-2-5-1-6%202l-3%202c-1%200-2%200-2%202s-1%202-1%201h-3l-2-2c-2%200-2%200-1-2l2-3%202-1c1%200%202%200%202-2%200-3%200-3-2-3h-2l-2-2-2%201-2%201h-10v-2l-7-13c-6-6-8-7-13-7h-4v-5l-1-4c-2-1-2%200-2%204v5H73v-13c-1-1-4%202-3%203l-1%204-1%2018%202%202v1l-1%204c0%204%200%204-3%203l-2-1v-2h1l1-2-3-1c-2%201-6-1-5-2l-1-2-1-8%201%202%202%202%201%202v3c0%202%203%203%203%201l1-4-1-3v-1l-1-1-1-1h2l1-2c0-2-1-2-7-2-10%200-11-1-11-19V82l3-3c3-3%204-3%209-3%204%200%206%200%205-1-4-1-2-2%202-2%201%200%202%200%201-2l1-2v-7l-1-2c1-3%206%204%205%207-1%206-1%207-3%206v1l-1%202c-2%200-1%201%201%204%204%205%205%205%205%201s1-5%204-5l2-1c-2-1%204-4%207-3%203%200%203%203-1%202l-3%201c-1%201%200%201%201%201%202%200%202%200%202%207v7l1-7v-7h11v8l1%2016%201%208v2c1%203%202-1%202-16l1-17%208-1h8v5c0%204%200%204-3%204-2%200-3%200-3%202s0%202%203%202l4%201v1l-1%203c0%203-1%204-3%204-3%200-3%201-3%204%200%204%200%204%204%204s4%200%204%203l-1%205%204%201h6c1-1-3-2-5-1-2%200-2%200-2-13V83c0-6%200-7%203-7%202%200%203%200%203-6v-9c1-2%200-4-3-7l-3-3V24l-3-2-6-4c-7-7-11-9-13-4-1%205-1%205%203%205l5%201v36H97V41c0-27-1-32-7-38-4-3-4-3-15-3S63%200%2065%204c1%202%200%209-3%2011-2%202-3%200-3-4V9c0%202-3%201-3%200V0h-5c-6%201-8%203-5%205l1%203c-1%204-2%204-3%201%200-4-3-9-5-9l-2%201m127%201v3l1%203h-2c-1-1-2-2-3-1-2%200-2%200-1%201%202%201%201%204-1%204l-2-2-1-2c-3%200-3%202-2%204v2c-1%201-2%200-2-4-1-4-2-3-4%203-1%205-1%208%201%205l5-2%204-1%202%201%202%201c1-1%202%200%203%201l2%201%202%201h2l2%201%201%202-2%201c-2%200-2%200-2%204l4%2021c1%201%202-7%202-18V20l3-1c4%200%205-2%203-4v-3c1-4-3-3-4%202-1%203-3%205-3%202l-2-2c-2-1-3-3-3-5-1-5-4-9-5-7m-43%205c-11%201-11%201-8%205l5%206c3%204%205%205%208%203l4-2c2%200%204-10%203-13l-12%201m146%2014c-3%202-3%202-3%208s-1%205%208%2012l3%202h-11v4c0%206%203%208%2011%209%2011%201%2014-2%2013-12-1-5-2-7-8-11-1-1-1-1%202-1%204%201%205-1%204-5-1-8-11-11-19-6M6%2025c0%204%200%204-2%204H1l3%2014c1%202%201%202-1%202s-2%201-2%205l1%206v2c-1%202%200%204%203%207l2%205%201%202h5c4%201%204%201%206-1l5-5c3-1%203-2%203-4-1-4%200-4%206-1l6%202c3-1%202-3-2-5l-2-2c2%200%201-3-1-3l-2-1-2-3-3-3c0-2-1-2-3-2-9%201-12%200-15-3-4-4-4-8-1-14%203-5%203-6-1-6-2%200-2%200-1%204m347%2031l-1%206v2c0-2-3-1-4%201v7l1%202c0%203%202%206%204%206l1%201%202%204c2%202%202%202%204%201%201-1%201-1%203%201%202%203%203%203%203%200l1-2%201-5%201-3c1%201%202-2%201-3l-1-2a62%2062%200%2001-7-1c-2%200-2%200-1-2%201-1%200-2-2-4s-2-3-2-6c1-4-2-7-4-3M48%2057c-2%203-2%207-1%209l1%202c-1%202%201%201%202%200s3-3%205-3c5-2%205-5%201-6l-4-3c-1-1-2-1-4%201m179%2020h-8v36h4c6%201%206%201%206-7%200-5%200-7%201-6l1%206c-1%207-1%207%206%207h4v-8l-1-9-2-1%202-2c1-1%202-10%200-13s-4-4-13-3m21%201c-3%203-3%203-3%2016s0%2014%203%2017c2%203%203%203%208%203l9-1h4V94h-6c-5%200-6%200-6%202-1%201-1-1-1-5%200-7%202-10%202-3l1%204h10v-5c0-8-3-10-12-11-6%200-7%200-9%202M2%2082c-2%203-1%208%201%208%204%200%206%200%207%202l4%201h2l1%201%201-4c0-4-3-5-9-4-4%200-7-2-5-3l1-2c0-2-2-1-3%201m386-1v3c0%202%200%202-3%202-4%200-4%200-4%202%200%203-1%205-2%205l-1-1c0-3-1-2-4%200-2%203-2%206%200%204h3c3%202%207%201%207-2%200-4%202-6%204-5l2-1v-3c2-3%200-7-2-4M57%2087l-1%2010c1%208%202%2011%203%204%200-4%200-4%205-4%203-1%205-1%206-3s2-2%202-1c1%201%201%200%201-1l-1-5c-2-1-2-1-2%202s0%203-5%203h-6v-3c0-5-2-6-2-2m213%2032l-2%203-1%204c-2%203-1%205%202%203l1-2%205%204-8%203c-3%200-4%201-3%203s7%202%208-1l3-3c2%200%202-1%202-4l1-6c3-4%202-5-2-5l-6%201m-242%206l-4%204%208%204%204%203c4%204%206%204%208%201%201-2%202-2%206-2%205%201%205%201%201-4-5-7-16-10-23-6m-11%2018l-3%201c-3%200-3%200-3%203s0%203-2%203c-3%200-4%202-2%205s5%204%205%202c0-3%201-2%204%201%203%202%203%204-1%202-1-1-2-1-2%201l1%202h10l3-3c2-1%202-1%205%202%204%205%205%205%205%201%200-1-1-3-3-3l-2-2-1-1-2-4c-1-7-10-15-12-10m135%2024c0%202-3%204-4%203s-2%200-3%203l-1%203v1h-3c-2-1-2-1-2%201l-1%203-1-6v-6l-2%204-1%209-1%207-2%203%202-1h4l2-1c1%201%201%200%201-2s0-3-1-2l-1%202-1%201-1-2%201-3c0-2%200-2%202-1%202%202%207%202%207%200v-2l3%204%201%202%201-3%201-5v-13%201m165%206c-4%202-6%205-6%209s0%204%202%203l4%201h1l3-2%203-3c1-3%203-4%203-1l2%201c2-1%201-4-2-7-2-2-6-3-10-1m-133%2051v2c0%201-5%202-7%200h-2l-7%205h3l3%201c0%202%201%202%202%202h2l-1%201-1%202h-3c-2-2-4-1-2%201s5%203%205%201l2-1c1%200%202%202%200%202-1%201-1%201%201%203%202%204%203%204%203%201%200-2%201-2%206-1%202%201%205-1%203-2l-1-5c-1-3-1-3%201-2%201%202%203%201%201-1-1-1-1-2%201-2l1-2c-1-2-3-1-3%201l-2%201c-2%200-3-2-1-4%201-1-2-4-4-3m-85%2031c1%206%205%2010%208%209l5%201c5%203%208%201%2011-3%202-5%201-6-3-3-3%203-4%203-7%202-6-2-9-5-11-8-2-4-3-4-3%202m-4%2013c-2%205-2%207%200%207l2%202v2c1%200%202%201%201%203%200%202%201%203%203%201h2c0%203%202%203%203%202l3-2%202-1-2-1c-3%201-6-1-4-2h3c1%201%201%201%201-1l-2-2-3-1h-1l-1-1c1-2-7-8-7-6m168%2028l1%202%201%201c0%202-4%205-6%205s-3%202-1%204l1%202c0%202%205%207%207%207s2-1%202-2c-2-8-3-7%201-7%203%201%203%201%202-1l-1-3-1-3c1-5%200-6-2-6h-3c-1-1-1%200-1%201m69%20122l-1%203-1%203-1%204-1%203-1%204c-2%201%203%205%205%205v1h-7c-2%202%201%204%206%204%202%200%203%200%202%201l3%207c2%200%202-5%200-10-1-4-2-11-2-23%200-4-2-6-2-2m-86%204l1%203c1%201%200%205-1%205l-1-1-1-2-1%202-1%202v-6l-2-3c-4-3-4-2-3%202l1%205c-1%201-6-1-6-3l-2-1-1-2c2-2-1-1-4%203-4%204-4%204%202%204%204-1%205-1%205%201l-2%202-4%202-5%203c-2%200-2%200-2-3v-3l-1%206c0%203-3%203-4-1%200-2%200-2-1%200-3%206%204%207%2014%202l5-2c0%201%201%201%201-1h3c2%201%203%201%203-1h2c3%201%203%201%203-1l2-2c1%201%202%200%202-1l2-1%201%202c-1%203%203%203%204%200%202-3%201-4-1-3-1%201-1%201-1-1%201-1%201-2-1-2-1-1-2-1-1-2l-1-3c-3-3-4-3-4%201m-18%2026c-1%202-2%202-3%201%200-1-2-1-3%201l-4%201c-3%200-4%206-1%206v-2l3-1c3%201%203%201%203-1v-2l1%202c1%203%203%203%204%201h1v2l2%201%202-1c0-3%202-2%203%200%200%202%202%203%203%201l-1-1v-2l1-1c-2%200-6-4-6-6%200-3-2-2-5%201m112%2059l-1%203c1%201%200%204-2%204s-1%201%202%204l2%204c0%202%208%203%2012%201l7-1h2l-1-1-4-1-3-1-3-2c-2-2-2-4%201-4l1-1-2-1c-3%200-9-2-9-4l-1-2-1%202m-27%2036l-2%201%201%201h1l-1%202v4c2%203%201%206-3%208l-2%202c1%201-2%204-3%204l1-4v-4c-2-1-2-1-3%202-2%203-2%204-4%203l-4-2c-2%200-4-2-5-4-1-3-2-3-3-2-3%204%204%2012%2013%2012%2011%201%2014%200%2019-5%205-4%206-8%202-12v-3l-1-2c-2-2-3-2-6-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/623450dfe36916d72f128cd0e2751b98/ca0a1/full-875511040-h8EB4D6E9-.webp 223w", "/static/623450dfe36916d72f128cd0e2751b98/5f7f2/full-875511040-h8EB4D6E9-.webp 273w"],
              "sizes": "(max-width: 273px) 100vw, 273px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/623450dfe36916d72f128cd0e2751b98/853b2/full-875511040-h8EB4D6E9-.jpg 223w", "/static/623450dfe36916d72f128cd0e2751b98/e2ee2/full-875511040-h8EB4D6E9-.jpg 273w"],
              "sizes": "(max-width: 273px) 100vw, 273px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/623450dfe36916d72f128cd0e2751b98/e2ee2/full-875511040-h8EB4D6E9-.jpg",
              "alt": "full 875511040 h8EB4D6E9 ",
              "title": "full 875511040 h8EB4D6E9 ",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Yeah that was 12 years ago my friends. We're getting old. Some of you might not even remember. A coworker recently said he's "happy that the internet has moved on from such silly nonsense".`}</p>
    <p>{`Kids these days have TikTok and Snapchat filters so has it really? 🤔`}</p>
    <p>{`Anyway, Adam Lindsay asked the important question: `}<em parentName="p">{`"What if you could write code like cats speak?"`}</em>{`. LOLCODE was the answer.`}</p>
    <p>{`Despite a never quite finished spec, several interpreters exist and maybe a compiler or two. I wasn't able to find a JavaScript compiler even though interpreters do exist.`}</p>
    <p>{`One such interpreter is `}<a parentName="p" {...{
        "href": "https://github.com/markwatkinson/loljs"
      }}>{`loljs by Mark Watkinson`}</a>{`. I used it as the basis for my compiler.`}</p>
    <p><em parentName="p">{`Aside: an `}{`[interpreter]`}{`(`}<a parentName="em" {...{
          "href": "https://en.wikipedia.org/wiki/Interpreter"
        }}>{`https://en.wikipedia.org/wiki/Interpreter`}</a></em>{`(computing)) executes your code as it's read, a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Compiler"
      }}>{`compiler`}</a>{` translates it to a different language (or machine code) to be executed later. Important distinction`}{`_`}</p>
    <h2 {...{
      "id": "what-is-a-babel-macro"
    }}>{`What is a Babel macro`}</h2>
    <p>{`A Babel macro is a sort of language extension for JavaScript. Since modern JavaScript is a compiled language, usually from modern JS to ES5, we can add fun features to the compilation step.`}</p>
    <p>{`The most common type of Babel macro are prefixed ES6 strings. You may have seen them as GraphQL queries or CSS-in-JS. JSX is a Babel plugin. Similar to a macro but different mechanics.`}</p>
    <p>{`For example:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20query%20%3D%20graphql%60%0A%09query%20%7B%0A%09%09posts%20%7B%0A%09%09%09author%0A%09%09%09body%0A%09%09%09time%0A%09%09%7D%0A%09%7D%0A%60"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "278px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "119.28251121076232%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'476\\'%20viewBox=\\'0%200%20400%20476\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M49%2072c-3%203-3%2025-3%20188%200%20156%200%20147%206%20149h297c6-2%206%207%206-149%200-163%200-185-3-188S52%2069%2049%2072m51%2022c-6%205-2%2014%205%2014%208%200%2012-8%206-14-4-4-7-4-11%200m29%200c-3%203-3%206-2%209%204%208%2015%205%2015-4%200-6-9-9-13-5m104%2061c-2%204%201%2011%205%2010h1l-3%202c-3%200-3%202%200%202%204%200%205-2%205-9v-7h-3c-3%200-4%201-5%202m34%206c0%207%201%2011%202%206%200-2%201-2%202-2%202%200%205-3%205-6%200-4-2-6-6-6h-3v8m24-7c-3%204%200%2012%204%2010%202%200%202%200%202%202l1%203%201-8v-8h-3l-5%201m-128%2059c0%206%200%207%202%207l1-2c0-1%201-2%203-2s4-3%203-7c0-3-2-4-6-4h-3v8m47%2040l-1%208v7h3c4%200%206-1%206-4%201-3-1-7-3-7s-3-1-3-2c0-2-1-3-2-2m29%202l-2%202c-3%200-5%202-5%206%200%203%202%205%206%205h3v-8l-1-8-1%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e76e0cb40307b422b576da3097ae3ef0/ca0a1/techletter.app-screenshot-1558022400094.webp 223w", "/static/e76e0cb40307b422b576da3097ae3ef0/bd3df/techletter.app-screenshot-1558022400094.webp 278w"],
                "sizes": "(max-width: 278px) 100vw, 278px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e76e0cb40307b422b576da3097ae3ef0/e92b6/techletter.app-screenshot-1558022400094.png 223w", "/static/e76e0cb40307b422b576da3097ae3ef0/4e29d/techletter.app-screenshot-1558022400094.png 278w"],
                "sizes": "(max-width: 278px) 100vw, 278px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e76e0cb40307b422b576da3097ae3ef0/4e29d/techletter.app-screenshot-1558022400094.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`That is a Babel macro.`}</p>
    <p>{`At compile-time Babel looks for the `}<inlineCode parentName="p">{`graphql`}</inlineCode>{` function. `}<inlineCode parentName="p">{`graphql`}</inlineCode>{` compiles the query into a JavaScript function, which gets inserted in place of that string.`}</p>
    <p>{`When your browser executes the resulting JavaScript it has no idea that a string used to live there.`}</p>
    <p>{`Zero run-time overhead 🤘`}</p>
    <p>{`Macros are `}<em parentName="p">{`extremely`}</em>{` powerful and many programming communities have decided they're `}<em parentName="p">{`too`}</em>{` powerful. More trouble than they're worth.`}</p>
    <p>{`JavaScript so far has been sensible about sticking with obvious macros and not, say, overwriting how `}<inlineCode parentName="p">{`+`}</inlineCode>{` works.`}</p>
    <h2 {...{
      "id": "how-to-build-a-babel-macro"
    }}>{`How to build a Babel macro`}</h2>
    <p>{`The easiest way to build a Babel macro is with Kent C Dodds's `}<a parentName="p" {...{
        "href": "https://github.com/kentcdodds/babel-plugin-macros"
      }}>{`babel-plugin-macros`}</a>{` library. The `}<a parentName="p" {...{
        "href": "https://github.com/kentcdodds/babel-plugin-macros#author-docs"
      }}>{`author docs`}</a>{` are pretty good.`}</p>
    <p>{`You follow a 3 step process:`}</p>
    <ol>
      <li parentName="ol">{`Create a `}<inlineCode parentName="li">{`macro.js`}</inlineCode>{` file (naming convention matters)`}</li>
      <li parentName="ol">{`Get the wrapper function`}</li>
    </ol>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20%7B%20createMacro%20%7D%20from%20%22babel-plugin-macros%22%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "502px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.21973094170403%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'149\\'%20viewBox=\\'0%200%20400%20149\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040c-1%201-2%208-2%2035%200%2032%200%2033%202%2035l2%202h342l2-2c2-2%202-3%202-35%200-27-1-34-2-35-2-3-344-3-346%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/39250571c750f534a742756bc787c7db/ca0a1/techletter.app-screenshot-1558022399498.webp 223w", "/static/39250571c750f534a742756bc787c7db/75680/techletter.app-screenshot-1558022399498.webp 445w", "/static/39250571c750f534a742756bc787c7db/20682/techletter.app-screenshot-1558022399498.webp 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/39250571c750f534a742756bc787c7db/e92b6/techletter.app-screenshot-1558022399498.png 223w", "/static/39250571c750f534a742756bc787c7db/e66bf/techletter.app-screenshot-1558022399498.png 445w", "/static/39250571c750f534a742756bc787c7db/eea79/techletter.app-screenshot-1558022399498.png 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/39250571c750f534a742756bc787c7db/eea79/techletter.app-screenshot-1558022399498.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Write your function`}</li>
    </ol>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20myMacro(%7B%20references%2C%20state%2C%20babel%20%7D)%20%7B%0A%09%2F%2F%20...%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "486px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.73991031390135%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'184\\'%20viewBox=\\'0%200%20400%20184\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2042c-2%203-1%2099%200%20102%203%203%20343%203%20346%200%201-3%202-99%200-102S29%2039%2027%2042\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/070f69c8e884c943e2c37c7838d6848e/ca0a1/techletter.app-screenshot-1558022399569.webp 223w", "/static/070f69c8e884c943e2c37c7838d6848e/75680/techletter.app-screenshot-1558022399569.webp 445w", "/static/070f69c8e884c943e2c37c7838d6848e/aba12/techletter.app-screenshot-1558022399569.webp 486w"],
                "sizes": "(max-width: 486px) 100vw, 486px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/070f69c8e884c943e2c37c7838d6848e/e92b6/techletter.app-screenshot-1558022399569.png 223w", "/static/070f69c8e884c943e2c37c7838d6848e/e66bf/techletter.app-screenshot-1558022399569.png 445w", "/static/070f69c8e884c943e2c37c7838d6848e/4ee7f/techletter.app-screenshot-1558022399569.png 486w"],
                "sizes": "(max-width: 486px) 100vw, 486px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/070f69c8e884c943e2c37c7838d6848e/4ee7f/techletter.app-screenshot-1558022399569.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Default export your function wrapped in `}<inlineCode parentName="li">{`createMacro`}</inlineCode></li>
    </ol>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=export%20default%20createMacro(myMacro)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "390px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.98206278026906%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'192\\'%20viewBox=\\'0%200%20400%20192\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M35%2052c-2%202-2%208-2%2046%200%2042%200%2043%202%2045%203%203%20328%203%20331%200%202-2%202-3%202-45%200-38%200-44-2-46l-1-2H36l-1%202m36%2016c-2%203-2%204%200%207%203%204%2010%202%2010-4s-6-8-10-3m21%200c-3%202-3%204%200%207%205%205%2012-1%209-7-3-3-6-3-9%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ec18c55197a7fce50210e04049af36c7/ca0a1/techletter.app-screenshot-1558022399697.webp 223w", "/static/ec18c55197a7fce50210e04049af36c7/a9b47/techletter.app-screenshot-1558022399697.webp 390w"],
                "sizes": "(max-width: 390px) 100vw, 390px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ec18c55197a7fce50210e04049af36c7/e92b6/techletter.app-screenshot-1558022399697.png 223w", "/static/ec18c55197a7fce50210e04049af36c7/727ba/techletter.app-screenshot-1558022399697.png 390w"],
                "sizes": "(max-width: 390px) 100vw, 390px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ec18c55197a7fce50210e04049af36c7/727ba/techletter.app-screenshot-1558022399697.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Somehow this creates a named export. I'm not sure why or how, but that's how it is. Best not to poke.`}</p>
    <p>{`You also `}<em parentName="p">{`cannot export anything alongside your macro`}</em>{`. Which is a shame and caused me many grief. You can work around it by letting people import other files in your library.`}</p>
    <h3 {...{
      "id": "your-macro-function"
    }}>{`Your macro function`}</h3>
    <p>{`The macro function itself can get tricky. You're dealing with `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Abstract_syntax_tree"
      }}>{`Abstract Syntax Trees (AST)`}</a>{`. It's up to you to modify as you see fit.`}</p>
    <p>{`In my case that was finding all `}<inlineCode parentName="p">{`lolcode`}</inlineCode>{` nodes and replacing them with compiled code.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20myMacro(%7B%20references%2C%20state%2C%20babel%20%7D)%20%7B%0A%20%20%20%20references.lolcode.forEach(referencePath%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20const%20compiled%20%3D%20compileLolcode(referencePath)%3B%0A%20%20%20%20%20%20%20%20referencePath.parentPath.replaceWithSourceString(compiled)%3B%0A%20%20%20%20%7D)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "638px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.497757847533634%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'174\\'%20viewBox=\\'0%200%20400%20174\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2031l-1%2057c0%2053%200%2055%202%2056h356c2-1%202-3%202-56l-1-57c-2-2-356-2-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d59bf4a7623d4d4906d830e06d2dbf50/ca0a1/techletter.app-screenshot-1558022399620.webp 223w", "/static/d59bf4a7623d4d4906d830e06d2dbf50/75680/techletter.app-screenshot-1558022399620.webp 445w", "/static/d59bf4a7623d4d4906d830e06d2dbf50/a2d8a/techletter.app-screenshot-1558022399620.webp 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d59bf4a7623d4d4906d830e06d2dbf50/e92b6/techletter.app-screenshot-1558022399620.png 223w", "/static/d59bf4a7623d4d4906d830e06d2dbf50/e66bf/techletter.app-screenshot-1558022399620.png 445w", "/static/d59bf4a7623d4d4906d830e06d2dbf50/41be6/techletter.app-screenshot-1558022399620.png 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d59bf4a7623d4d4906d830e06d2dbf50/41be6/techletter.app-screenshot-1558022399620.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`references`}</inlineCode>{` is a reference to the JavaScript AST. `}<inlineCode parentName="p">{`state`}</inlineCode>{` and `}<inlineCode parentName="p">{`babel`}</inlineCode>{` are the same as they are in a normal Babel plugin. Which isn't helpful, if you've never built a Babel plugin 😅`}</p>
    <p>{`My macro ends up replacing each lolcode's parent node with the compiled string. That worked well.`}</p>
    <h2 {...{
      "id": "how-to-build-a-compiler"
    }}>{`How to build a compiler`}</h2>
    <p>{`Most compilers are split into 3 parts:`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Compiler#Front_end"
        }}>{`The front-end`}</a>{`, which uses a Lexer and a Parser to turn your code into an AST`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Compiler#Middle_end"
        }}>{`The middle-end`}</a>{`, which performs optimizations and other transformations on your AST`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Compiler#Back_end"
        }}>{`The back-end`}</a>{`, which turns your AST into the final output code`}</li>
    </ol>
    <p>{`In theory you can swap these parts around.`}</p>
    <p>{`Once you have a back-end that generates JavaScript from an AST, you can attach different front-ends to compile other languages to JavaScript. Once you have a front-end, you can use different target outputs. Etc.`}</p>
    <p>{`Best explained with a LOLCODE example 👇`}</p>
    <h2 {...{
      "id": "creating-a-lolcode-to-javascript-compiler"
    }}>{`Creating a LOLCODE-to-JavaScript compiler`}</h2>
    <p>{`The swappability of compiler parts is what helped me build `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lolcode-babel-macro"
      }}>{`lolcode-babel-macro`}</a>{`.`}</p>
    <p>{`I found a working lexer-parser-AST online, `}<a parentName="p" {...{
        "href": "https://github.com/markwatkinson/loljs"
      }}>{`loljs by Mark Watkinson`}</a>{`, updated it to work in modern JavaScript creating `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/loljs"
      }}>{`@swizec/loljs`}</a>{`, and replaced the interpreting back-end with a compiler.`}</p>
    <h3 {...{
      "id": "the-tokenizer-lexer-and-parser"
    }}>{`The tokenizer, lexer, and parser`}</h3>
    <p>{`The first step in compiling code is a tokenizer. `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Lexical_analysis#Tokenization"
      }}>{`Tokenizers`}</a>{` take plain strings or files and turn them into lists of tokens. Usually a combination of split-by-space and regex.`}</p>
    <p>{`The LOLCODE tokenizer turns strings like `}<inlineCode parentName="p">{`O RLY?`}</inlineCode>{` into `}<inlineCode parentName="p">{`O_RLY`}</inlineCode>{` tokens, `}<inlineCode parentName="p">{`I HAS A`}</inlineCode>{` into `}<inlineCode parentName="p">{`VAR_DEC`}</inlineCode>{`, `}<inlineCode parentName="p">{`BIGGR THAN`}</inlineCode>{` into `}<inlineCode parentName="p">{`BIN_OP`}</inlineCode>{` etc. You can see the full list `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/loljs/blob/master/src/loljs.jison"
      }}>{`here`}</a>{`, lines 6 to 86.`}</p>
    <h4 {...{
      "id": "the-lexer"
    }}>{`The lexer`}</h4>
    <p>{`The next step is a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Lexical_analysis"
      }}>{`lexer`}</a>{`, which turns combinations of tokens into recognizable sequences. This is your grammar definition and is best used with a parser generator like `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/GNU_Bison"
      }}>{`bison`}</a>{`, or its JavaScript counterpart `}<a parentName="p" {...{
        "href": "https://github.com/zaach/jison"
      }}>{`jison`}</a>{`.`}</p>
    <p>{`You don't want to write your own parser from scratch, trust me.`}</p>
    <p>{`The full grammar definition for LOLCODE lives here 👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/loljs/blob/master/src/loljs.jison"
      }}>{`loljs.jison`}</a>{`.`}</p>
    <p>{`It's a series of lexical definitions 👇`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=jison&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function_call%0A%20%20%20%20%3A%20IDENTIFIER%20arg_list%20arg_end%0A%20%20%20%20%20%20%20%20%7B%20%24%24%20%3D%20new%20ast.FunctionCall(%40%24%2C%20%241%2C%20%242)%3B%20%7D%0A%20%20%20%20%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "502px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.98206278026906%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'192\\'%20viewBox=\\'0%200%20400%20192\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040c-1%201-2%2011-2%2056%200%2054%200%2055%202%2057l2%202h342l2-2c2-2%202-3%202-57%200-45-1-55-2-56-2-3-344-3-346%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/707ff0a7bd63b07f88d38f7eb7f80794/ca0a1/techletter.app-screenshot-1558022499510.webp 223w", "/static/707ff0a7bd63b07f88d38f7eb7f80794/75680/techletter.app-screenshot-1558022499510.webp 445w", "/static/707ff0a7bd63b07f88d38f7eb7f80794/20682/techletter.app-screenshot-1558022499510.webp 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/707ff0a7bd63b07f88d38f7eb7f80794/e92b6/techletter.app-screenshot-1558022499510.png 223w", "/static/707ff0a7bd63b07f88d38f7eb7f80794/e66bf/techletter.app-screenshot-1558022499510.png 445w", "/static/707ff0a7bd63b07f88d38f7eb7f80794/eea79/techletter.app-screenshot-1558022499510.png 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/707ff0a7bd63b07f88d38f7eb7f80794/eea79/techletter.app-screenshot-1558022499510.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`A function call has an `}<inlineCode parentName="p">{`IDENTIFIER`}</inlineCode>{`, followed by an `}<inlineCode parentName="p">{`arg_list`}</inlineCode>{` node, and an `}<inlineCode parentName="p">{`arg_end`}</inlineCode>{` node.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=jison&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=arg_end%0A%20%20%20%20%3A%20MKAY%20%7B%24%24%20%3D%20%241%3B%7D%0A%20%20%20%20%7C%20eol%0A%20%20%20%20%3B%0A%0Aarg_list%0A%20%20%20%20%3A%20exp%0A%20%20%20%20%20%20%20%20%7B%20%24%24%20%3D%20new%20ast.ArgList(%40%24%2C%20%5B%241%5D)%3B%20%7D%0A%20%20%20%20%7C%20arg_list%20SEP%20exp%0A%20%20%20%20%20%20%20%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%241.push(%243)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%24%24%20%3D%20%241%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "446px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "94.61883408071749%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'378\\'%20viewBox=\\'0%200%20400%20378\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2044c-3%202-3%20289%200%20291h338c3-2%203-289%200-291H31\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/272d2273ebfbc786038d15e85e8525ef/ca0a1/techletter.app-screenshot-1558022399848.webp 223w", "/static/272d2273ebfbc786038d15e85e8525ef/75680/techletter.app-screenshot-1558022399848.webp 445w", "/static/272d2273ebfbc786038d15e85e8525ef/5021b/techletter.app-screenshot-1558022399848.webp 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/272d2273ebfbc786038d15e85e8525ef/e92b6/techletter.app-screenshot-1558022399848.png 223w", "/static/272d2273ebfbc786038d15e85e8525ef/e66bf/techletter.app-screenshot-1558022399848.png 445w", "/static/272d2273ebfbc786038d15e85e8525ef/6244b/techletter.app-screenshot-1558022399848.png 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/272d2273ebfbc786038d15e85e8525ef/6244b/techletter.app-screenshot-1558022399848.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`arg_end`}</inlineCode>{` and `}<inlineCode parentName="p">{`arg_list`}</inlineCode>{` in turn are built out of more tokens and nodes. The rabbit hole goes very deep and I'm happy that somebody else wrote all that for me :)`}</p>
    <p>{`I remember doing this in my compilers class in college and `}<em parentName="p">{`it was not fun`}</em>{`. Easy to make mistakes, hard to verify.`}</p>
    <h4 {...{
      "id": "the-parser"
    }}>{`The parser`}</h4>
    <p>{`Jison takes your LOLCODE grammar and `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/loljs/blob/master/parser.js"
      }}>{`turns it into a parser`}</a>{`.`}</p>
    <p>{`A parser looks like normal JavaScript code except it's a little soupy and 3455 lines long. You really don't want to write parsers by hand.`}</p>
    <p>{`Here's what the parser code looks like`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=case%2062%3A%0A%20%20%20%20this.%24%20%3D%20new%20ast.Assignment(this._%24%2C%20%24%24%5B%240%20-%202%5D%2C%20%24%24%5B%240%5D)%3B%0A%20%20%20%20break%3B%0Acase%2063%3A%0A%20%20%20%20this.%24%20%3D%20new%20ast.Assignment(this._%24%2C%20%24%24%5B%240%20-%202%5D%2C%20%24%24%5B%240%5D)%3B%0A%20%20%20%20break%3B%0Acase%2064%3A%0A%20%20%20%20this.%24%20%3D%20new%20ast.Assignment(this._%24%2C%20%24%24%5B%240%20-%202%5D%2C%20%24%24%5B%240%5D)%3B%0A%20%20%20%20break%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "590px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'224\\'%20viewBox=\\'0%200%20400%20224\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2033l-1%2080v78l3%201h350l3-1v-78l-1-80c-2-2-352-2-354%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bcf18dc1ac671d9d63ef38129a84d81f/ca0a1/techletter.app-screenshot-1558022399881.webp 223w", "/static/bcf18dc1ac671d9d63ef38129a84d81f/75680/techletter.app-screenshot-1558022399881.webp 445w", "/static/bcf18dc1ac671d9d63ef38129a84d81f/5ca24/techletter.app-screenshot-1558022399881.webp 590w"],
                "sizes": "(max-width: 590px) 100vw, 590px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bcf18dc1ac671d9d63ef38129a84d81f/e92b6/techletter.app-screenshot-1558022399881.png 223w", "/static/bcf18dc1ac671d9d63ef38129a84d81f/e66bf/techletter.app-screenshot-1558022399881.png 445w", "/static/bcf18dc1ac671d9d63ef38129a84d81f/fcda8/techletter.app-screenshot-1558022399881.png 590w"],
                "sizes": "(max-width: 590px) 100vw, 590px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/bcf18dc1ac671d9d63ef38129a84d81f/fcda8/techletter.app-screenshot-1558022399881.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`A convoluted series of hundreds of `}<inlineCode parentName="p">{`new ast.X`}</inlineCode>{` calls to create an abstract syntax tree based on your grammar and your AST definition.`}</p>
    <p><img parentName="p" {...{
        "src": "/481c5be11500fd6a925b40be72cc1180/media-bPTXcJiIzzWz6-giphy.gif",
        "alt": "no_idea giphy"
      }}></img></p>
    <p>{`Best stick to defining the grammar and let parser generators do the rest.`}</p>
    <h3 {...{
      "id": "the-ast"
    }}>{`The AST`}</h3>
    <p>{`As you can see above, your parser needs an AST definition. What does your code look like as a JavaScript object tree?`}</p>
    <p>{`Again thanks to Mark Watkinson, I didn't have to write my own 👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/loljs/blob/master/src/ast.js"
      }}>{`the LOLCODE AST`}</a></p>
    <p>{`Defining your AST can be tedious, but it's not very complex. A function call node looks like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=lol.ast.FunctionCall%20%3D%20function%20(location%2C%20name%2C%20args)%20%7B%0A%20%20%20%20lol.ast.Node.call(this%2C%20location%2C%20'FunctionCall')%3B%0A%20%20%20%20this.name%20%3D%20name%3B%0A%20%20%20%20this.args%20%3D%20args%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "550px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.08520179372197%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'188\\'%20viewBox=\\'0%200%20400%20188\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2036c-2%202-2%20115%200%20117s350%202%20352%200%202-115%200-117-350-2-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5f55200c649ba74cb05a29357f45f66e/ca0a1/techletter.app-screenshot-1558022399680.webp 223w", "/static/5f55200c649ba74cb05a29357f45f66e/75680/techletter.app-screenshot-1558022399680.webp 445w", "/static/5f55200c649ba74cb05a29357f45f66e/12b65/techletter.app-screenshot-1558022399680.webp 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5f55200c649ba74cb05a29357f45f66e/e92b6/techletter.app-screenshot-1558022399680.png 223w", "/static/5f55200c649ba74cb05a29357f45f66e/e66bf/techletter.app-screenshot-1558022399680.png 445w", "/static/5f55200c649ba74cb05a29357f45f66e/dd45a/techletter.app-screenshot-1558022399680.png 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5f55200c649ba74cb05a29357f45f66e/dd45a/techletter.app-screenshot-1558022399680.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`To generate a `}<inlineCode parentName="p">{`FunctionCall`}</inlineCode>{` node, you need a `}<inlineCode parentName="p">{`location`}</inlineCode>{`, a `}<inlineCode parentName="p">{`name`}</inlineCode>{`, and some `}<inlineCode parentName="p">{`args`}</inlineCode>{`. All coming from your parser.`}</p>
    <p>{`You return a `}<inlineCode parentName="p">{`Node`}</inlineCode>{` called `}<inlineCode parentName="p">{`FunctionCall`}</inlineCode>{`, define its `}<inlineCode parentName="p">{`name`}</inlineCode>{` (identifier), and `}<inlineCode parentName="p">{`args`}</inlineCode>{` node. All very recursive and following the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Visitor_pattern"
      }}>{`visitor pattern`}</a></p>
    <p>{`The resulting AST is an object a little like this (writing from memory)`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%7B%0A%09location%3A%20%7B%20...%20%7D%2C%0A%09type%3A%20%60FunctionCall%60%0A%09name%3A%20'myFunction'%2C%0A%09args%3A%20%7B%0A%09%09location%3A%20%7B%20...%20%7D%2C%0A%09%09type%3A%20%60ArgsList%60%2C%0A%09%09argsList%3A%20%5B%0A%09%09%09Node%2C%20Node%2C%20Node%20...%0A%09%09%5D%0A%09%7D%2C%0A%09body%3A%20%7B%0A%09%09location%3A%20%7B%20...%20%7D%0A%09%09type%3A%20%60Body%60%2C%0A%09%09lines%3A%20%5B%20Node%2C%20Node%2C%20Node%20%5D%0A%09%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "382px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "124.2152466367713%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'497\\'%20viewBox=\\'0%200%20400%20497\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M36%2053c-2%201-2%2020-2%20197v196l2%201c2%202%2019%202%20165%202%20145%200%20162%200%20164-2l2-1V250c0-177%200-196-2-197-2-3-327-3-329%200m37%2016c-4%204-1%2010%204%2010%203%200%206-3%206-6%200-5-7-8-10-4m21%200c-5%206%202%2013%207%208%204-3%204-5%201-8s-6-3-8%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/803c2a526395a6b0cbbec0b5be929e46/ca0a1/techletter.app-screenshot-1558022398328.webp 223w", "/static/803c2a526395a6b0cbbec0b5be929e46/c5024/techletter.app-screenshot-1558022398328.webp 382w"],
                "sizes": "(max-width: 382px) 100vw, 382px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/803c2a526395a6b0cbbec0b5be929e46/e92b6/techletter.app-screenshot-1558022398328.png 223w", "/static/803c2a526395a6b0cbbec0b5be929e46/77edc/techletter.app-screenshot-1558022398328.png 382w"],
                "sizes": "(max-width: 382px) 100vw, 382px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/803c2a526395a6b0cbbec0b5be929e46/77edc/techletter.app-screenshot-1558022398328.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`An AST is a recursive JavaScript data structure. Once you get used to a node or two, everything follows familiar patterns.`}</p>
    <h3 {...{
      "id": "the-js-output"
    }}>{`The JS output`}</h3>
    <p>{`It's these recursive AST patterns that make compiling to JavaScript so accessible. Define a method for each node type and recursively call the compiler when needed.`}</p>
    <p>{`Like this 👇`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20The%20macro%20part%0Afunction%20compileLolcode(referencePath)%20%7B%0A%20%20%20%20const%20source%20%3D%20referencePath.parentPath.node.quasi.quasis%0A%20%20%20%20%20%20%20%20.map(node%20%3D%3E%20node.value.raw)%0A%20%20%20%20%20%20%20%20.join(%22%22)%3B%0A%0A%20%20%20%20const%20ast%20%3D%20parser.parse(source)%3B%0A%20%20%20%20const%20jsify%20%3D%20new%20JSify()%3B%0A%0A%20%20%20%20return%20%60(function%20(stdlib)%20%7B%0A%20%20%20%20%20%20%20%20return%20function()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%24%7Bjsify.compile(ast)%7D%20%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D)(lolstdlib)%60%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "590px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.43946188340806%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'298\\'%20viewBox=\\'0%200%20400%20298\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2034a5102%205102%200%20001%20231h353l1-116V34l-178-1-177%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c60107d86a99ca698869958c7e781753/ca0a1/techletter.app-screenshot-1558022398549.webp 223w", "/static/c60107d86a99ca698869958c7e781753/75680/techletter.app-screenshot-1558022398549.webp 445w", "/static/c60107d86a99ca698869958c7e781753/5ca24/techletter.app-screenshot-1558022398549.webp 590w"],
                "sizes": "(max-width: 590px) 100vw, 590px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c60107d86a99ca698869958c7e781753/e92b6/techletter.app-screenshot-1558022398549.png 223w", "/static/c60107d86a99ca698869958c7e781753/e66bf/techletter.app-screenshot-1558022398549.png 445w", "/static/c60107d86a99ca698869958c7e781753/fcda8/techletter.app-screenshot-1558022398549.png 590w"],
                "sizes": "(max-width: 590px) 100vw, 590px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c60107d86a99ca698869958c7e781753/fcda8/techletter.app-screenshot-1558022398549.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Kent's babel macros plugin gives us the JavaScript AST. We use it to find our LOLCODE source. Hiding in `}<inlineCode parentName="p">{`parentPath.node.quasi.quasis`}</inlineCode>{` in this case. We walk through all `}<inlineCode parentName="p">{`quasis`}</inlineCode>{`, get their `}<inlineCode parentName="p">{`raw`}</inlineCode>{` values, and join them into a string.`}</p>
    <p>{`That's how prefixed ES6 strings work, don't know why.`}</p>
    <p>{`Take the resulting `}<inlineCode parentName="p">{`source`}</inlineCode>{` code, `}<inlineCode parentName="p">{`parse`}</inlineCode>{` it, instantiate the `}<inlineCode parentName="p">{`JSify`}</inlineCode>{` compiler backend, and return the output as a string. We wrap compiled code in a closure with the LOLCODE stdlib, which defines some basic functions.`}</p>
    <p>{`All your LOLCODE instances share the same stdlib. Assumed to exist in scope via an import.`}</p>
    <h4 {...{
      "id": "jsify--translate-an-ast-to-javascript"
    }}>{`JSify – translate an AST to JavaScript`}</h4>
    <p>{`Compiling an AST to JavaScript is now a matter of recursively calling node-specific methods on the JSify object and return strings. Each method on its own is pretty small, but when they work together, the result is magical.`}</p>
    <p>{`You can see `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lolcode-babel-macro/blob/master/src/JSify.js"
      }}>{`the full JSify file here`}</a>{`.`}</p>
    <p>{`Keeping with our FunctionCall example from earlier ...`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20%20%20FunctionCall%20%3D%20(node%2C%20newIT)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20if%20(stdlib%5Bnode.name%5D)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20return%20%60stdlib%5B%22%24%7Bnode.name%7D%22%5D(%24%7Bthis.compile(node.args)%7D)%60%3B%0A%20%20%20%20%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20return%20%60%24%7Bnode.name%7D(%24%7Bthis.compile(node.args)%7D)%60%3B%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "678px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.497757847533634%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'174\\'%20viewBox=\\'0%200%20400%20174\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2029l-1%2059%201%2057%204%201h353l4-1V88l-1-59c-2-2-358-2-360%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e0b6082db05d7536cf47e04fe3dccc59/ca0a1/techletter.app-screenshot-1558022399292.webp 223w", "/static/e0b6082db05d7536cf47e04fe3dccc59/75680/techletter.app-screenshot-1558022399292.webp 445w", "/static/e0b6082db05d7536cf47e04fe3dccc59/7e03f/techletter.app-screenshot-1558022399292.webp 678w"],
                "sizes": "(max-width: 678px) 100vw, 678px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e0b6082db05d7536cf47e04fe3dccc59/e92b6/techletter.app-screenshot-1558022399292.png 223w", "/static/e0b6082db05d7536cf47e04fe3dccc59/e66bf/techletter.app-screenshot-1558022399292.png 445w", "/static/e0b6082db05d7536cf47e04fe3dccc59/38cea/techletter.app-screenshot-1558022399292.png 678w"],
                "sizes": "(max-width: 678px) 100vw, 678px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e0b6082db05d7536cf47e04fe3dccc59/38cea/techletter.app-screenshot-1558022399292.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The `}<inlineCode parentName="p">{`FunctionCall`}</inlineCode>{` method gets a `}<inlineCode parentName="p">{`node`}</inlineCode>{` and a flag whether to instantiate a new `}<inlineCode parentName="p">{`IT`}</inlineCode>{` context. This keeps the same function signature throughout JSify.`}</p>
    <p><inlineCode parentName="p">{`IT`}</inlineCode>{` in LOLCODE is the implicit variable, by the way. Supposed to hold the value of the last expression ... but I had to take some liberties because this is a compiler not an interpreter. You have to explicitly assign values to `}<inlineCode parentName="p">{`IT`}</inlineCode>{`, but the variable is always there for you.`}</p>
    <p><inlineCode parentName="p">{`FunctionCall`}</inlineCode>{` then checks if this function is in `}<inlineCode parentName="p">{`stdlib`}</inlineCode>{` and returns the appropriate code. Either a stdlib call or a normal function call.`}</p>
    <p>{`We call `}<inlineCode parentName="p">{`this.compile`}</inlineCode>{` for the arguments node.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20%20%20ArgList%20%3D%20(node%2C%20newIT)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20return%20node.values.map(this.compile).join(%22%2C%20%22)%3B%0A%20%20%20%20%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "550px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "40.35874439461883%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'162\\'%20viewBox=\\'0%200%20400%20162\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2036c-2%202-2%2089%200%2091s350%202%20352%200%202-89%200-91-350-2-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7f5f5297902af244133111c64ddff41b/ca0a1/techletter.app-screenshot-1558022400666.webp 223w", "/static/7f5f5297902af244133111c64ddff41b/75680/techletter.app-screenshot-1558022400666.webp 445w", "/static/7f5f5297902af244133111c64ddff41b/12b65/techletter.app-screenshot-1558022400666.webp 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7f5f5297902af244133111c64ddff41b/e92b6/techletter.app-screenshot-1558022400666.png 223w", "/static/7f5f5297902af244133111c64ddff41b/e66bf/techletter.app-screenshot-1558022400666.png 445w", "/static/7f5f5297902af244133111c64ddff41b/dd45a/techletter.app-screenshot-1558022400666.png 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7f5f5297902af244133111c64ddff41b/dd45a/techletter.app-screenshot-1558022400666.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Compiling the `}<inlineCode parentName="p">{`ArgList`}</inlineCode>{` node is similar 👉 walk through list of values and recursively call `}<inlineCode parentName="p">{`this.compile`}</inlineCode>{` for each node. Who knows what expression might lie in there :)`}</p>
    <p><inlineCode parentName="p">{`this.compile`}</inlineCode>{` itself is pretty simple, a switch statement 👇`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20%20%20compile%20%3D%20(node%2C%20newIT%20%3D%20true)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20if%20(this%5Bnode._name%5D)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20node%20%3D%20this%5Bnode._name%5D(node%2C%20newIT)%3B%0A%20%20%20%20%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20throw%20new%20Error(%60Not%20implemented%3A%20%24%7Bnode._name%7D%60)%3B%0A%20%20%20%20%20%20%20%20%7D%0A%0A%20%20%20%20%20%20%20%20return%20node%3B%0A%20%20%20%20%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "598px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "55.15695067264574%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'221\\'%20viewBox=\\'0%200%20400%20221\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2034c-2%203-1%20153%201%20154%202%203%20352%203%20354%200%202-1%203-151%201-154S24%2031%2022%2034\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4ac036db43683b8a058214b3648c0a39/ca0a1/techletter.app-screenshot-1558022396696.webp 223w", "/static/4ac036db43683b8a058214b3648c0a39/75680/techletter.app-screenshot-1558022396696.webp 445w", "/static/4ac036db43683b8a058214b3648c0a39/83245/techletter.app-screenshot-1558022396696.webp 598w"],
                "sizes": "(max-width: 598px) 100vw, 598px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4ac036db43683b8a058214b3648c0a39/e92b6/techletter.app-screenshot-1558022396696.png 223w", "/static/4ac036db43683b8a058214b3648c0a39/e66bf/techletter.app-screenshot-1558022396696.png 445w", "/static/4ac036db43683b8a058214b3648c0a39/0c69d/techletter.app-screenshot-1558022396696.png 598w"],
                "sizes": "(max-width: 598px) 100vw, 598px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4ac036db43683b8a058214b3648c0a39/0c69d/techletter.app-screenshot-1558022396696.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Checks if it recognizes the node type and calls the appropriate method. If not, it throws an error.`}</p>
    <p>{`And that's how a bunch of small functions work together to produce complex JavaScript code based on your LOLCODE.`}</p>
    <iframe {...{
      "src": "https://codesandbox.io/embed/github/Swizec/lolcode.macro-example/tree/master/?fontsize=14",
      "style": {
        "width": "100%",
        "height": "500px",
        "border": "0",
        "borderRadius": "4px",
        "overflow": "hidden"
      },
      "allow": "accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking",
      "sandbox": "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
    }}></iframe>
    <h2 {...{
      "id": "but-why"
    }}>{`But why?`}</h2>
    <p><img parentName="p" {...{
        "src": "/7fbecbaa2c75b5deaa03e98221f41ec0/media-s239QJIh56sRW-giphy-downsized-medium.gif",
        "alt": "but_why giphy"
      }}></img></p>
    <p>{`Why not?`}</p>
    <p>{`LOLCODE is amazing, JavaScript is awesome, and putting them together is ... completely useless let's be honest. Intellectually gratifying but pointless.`}</p>
    <p>{`HOWEVER, this opens the door for future hacking 👇`}</p>
    <ol>
      <li parentName="ol">{`Great excuse to learn about Babel macros`}</li>
      <li parentName="ol">{`Superb way to practice building a small compiler`}</li>
      <li parentName="ol">{`Get some plug-and-play pieces of tech to build interesting DSLs for JavaScript`}</li>
      <li parentName="ol">{`Unlocks where I got stuck last time I tried to build an AI system that writes JavaScript based on specs`}</li>
    </ol>
    <p>{`That last part 😏`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      